import React, { useEffect, useState } from 'react'
import { Button, Divider, Flex, Typography } from 'antd'
import { useNavigate, useParams } from 'react-router-dom'
import { ImRadioChecked } from 'react-icons/im'
import { database } from '../../utils/firebase'
import TopBar from './TopBar'
import CommunicationButtons from './CommunicationButtons'

const { Title, Text, Link } = Typography

const SoapNotes = () => {
  const [soapNote, setSoapNotes] = useState()
  const [info, setInfo] = useState()
  const { chatID } = useParams()
  const navigate = useNavigate()
  const [subsequentSoapNotesArray, setSubsequentSoapNotesArray] = useState([])


  const fetchSoapNoteDetails = (chatID) => {
    database.ref(`labTracking/${chatID}`).once('value', async (snapshot) => {
      const response = snapshot.val()
      console.log('response', response)
      setSoapNotes(response)
      if (response?.oldSessions) {
        const keys = Object.values(response?.oldSessions || {})
        const promises = [...keys.map((key) => {
          return database.ref(`archiveConversations/${key}`).once('value').then((s) => {
            if (s.val()) {
              return {
                chatID: key,
                ...s.val(),
              }
            } else {
              return null
            }
          })
        })]
        const anyName = await Promise.all(promises)
        setSubsequentSoapNotesArray(anyName.filter(Boolean))
        console.log('anyName', anyName)
      }

    })
  }

  const fetchInfo = (chatID) => {

    chatID = chatID.replace('_labs', '').replace('_imaging', '')

    database.ref(`archiveConversations/${chatID}`).once('value', (snapshot) => {
      const response = snapshot.val()
      console.log('response Info', response)
      setInfo(response)
    })
  }
  useEffect(() => {
    fetchSoapNoteDetails(chatID)
    fetchInfo(chatID)

  }, [])

  return (
    <div>
      <TopBar title="SOAP Notes" />
      <Flex gap="small" style={{ padding: '8px' }}>
        <Text strong style={{ marginLeft: '10px' }}>
          {soapNote?.patientName}
        </Text>
        <Text>
          -Diagnosis : {soapNote?.assessment}
        </Text>
      </Flex>
      <Divider style={{ margin: 0 }} />

      <CommunicationButtons chatID={chatID} />
      {subsequentSoapNotesArray.length > 0 && (<>
        <Flex
          style={{ background: '#F3F3F3', padding: '8px', color: '#DF7467', alignItems: 'center' }}
          gap="small">
          <ImRadioChecked style={{ marginLeft: '10px' }} />
          <Text strong> Subsequent SOAP Notes:</Text>
        </Flex>
        {
          subsequentSoapNotesArray.map((value) => {
            const chatData = value?.soapNotesData
            return <SoapNotesCard chatID={value?.chatID} assessment={chatData?.assessment}
                                  timestamp={value.timestamp} />
          })

        }
      </>)}

      <Flex
        style={{

          background: '#F3F3F3',
          padding: '8px',
          color: '#DF7467',
          alignItems: 'center',

        }}
        gap="small">
        <ImRadioChecked style={{ marginLeft: '10px' }} />
        <Text strong> Requisition SOAP Notes:</Text>
      </Flex>
      <SoapNotesCard chatID={chatID} timestamp={soapNote?.timestamp} assessment={soapNote?.assessment} />


    </div>
  )
}
export default SoapNotes

const SoapNotesCard = ({ chatID, timestamp, assessment }) => {

  const navigate = useNavigate()
  return (
    <>
      <Flex vertical className="p-2">
        <Flex style={{ padding: '10px', alignItems: 'center' }} gap="small" justify="space-between">
          <Text underline strong>
            SOAP Notes:
          </Text>
          <Button onClick={() => navigate(`/viewsoapnotes/${chatID}`)} type="primary" shape="round">View</Button>
        </Flex>


        <Flex style={{ padding: '10px' }} justify="space-between">
          <Text> Chat ID:</Text>
          <Text> {chatID}</Text>
        </Flex>
        <Flex style={{ padding: '10px' }} justify="space-between">
          <Text> Date of encounter:</Text>
          <Text strong> {new Date(timestamp).toLocaleString()}</Text>
        </Flex>

        <Flex gap="small" style={{ padding: '10px' }} justify="space-between">
          <Text> Diagnosis:</Text>
          <Text> {assessment}</Text>
        </Flex></Flex>

      <Divider />
    </>
  )

}
